import { ISite } from 'app/shared/model//site.model';

export interface IZone {
  id?: number;
  name?: string;
  autoArrangeAsc?: boolean;
  freeSeating?: boolean;
  imageUrl?: string;
  site?: ISite;
}

export const defaultValue: Readonly<IZone> = {
  autoArrangeAsc: false,
  freeSeating: false
};
